import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "w-full min-w-0 min-h-0 bg-slate-50" }
const _hoisted_2 = { class: "w-full min-w-0 max-w-[100%] mx-auto px-3 sm:px-5 lg:px-6 xl:px-8 py-4 sm:py-6 lg:py-7" }
const _hoisted_3 = { class: "mb-6 sm:mb-8 flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between min-w-0" }
const _hoisted_4 = { class: "min-w-0 flex-1" }
const _hoisted_5 = { class: "text-2xl sm:text-3xl lg:text-4xl font-bold bg-gradient-to-r from-slate-900 to-slate-700 bg-clip-text text-transparent pb-1 break-words" }
const _hoisted_6 = {
  key: 1,
  class: "mt-2 text-xs text-slate-500 sm:hidden line-clamp-2"
}
const _hoisted_7 = { class: "flex flex-col xs:flex-row gap-2 w-full min-w-0 sm:w-auto sm:flex-shrink-0 sm:justify-end" }
const _hoisted_8 = {
  key: 0,
  class: "min-w-0 mb-4 sm:mb-5 text-sm text-slate-600"
}
const _hoisted_9 = { class: "min-w-0 space-y-4 sm:space-y-6" }


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminPageShell',
  props: {
    title: {},
    description: {},
    compactDescription: { type: Boolean, default: true }
  },
  setup(__props: any) {

/**
 * Contenedor de página admin: ancho fluido (sin max-w-7xl), min-w-0 para flex/grid
 * y cabecera consistente. Fase 1 del rediseño UX (módulos productos, vehículos, pedidos).
 */


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", _hoisted_5, _toDisplayString(__props.title), 1),
          (__props.description)
            ? (_openBlock(), _createElementBlock("p", {
                key: 0,
                class: _normalizeClass(["mt-2 text-sm sm:text-base text-slate-600 max-w-3xl break-words", __props.compactDescription ? 'hidden sm:block' : ''])
              }, _toDisplayString(__props.description), 3))
            : _createCommentVNode("", true),
          (__props.description && __props.compactDescription)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(__props.description), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _renderSlot(_ctx.$slots, "actions")
        ])
      ]),
      (_ctx.$slots.lead)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _renderSlot(_ctx.$slots, "lead")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ]))
}
}

})